import { render, staticRenderFns } from "./RbAppFooter.vue?vue&type=template&id=21d32ec6&"
import script from "./RbAppFooter.vue?vue&type=script&lang=js&"
export * from "./RbAppFooter.vue?vue&type=script&lang=js&"
import style0 from "./RbAppFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports